import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import { FaFacebookF as FacebookIcon } from "react-icons/fa"
import { FaTwitter as TwitterIcon } from "react-icons/fa"
import { FaPinterestP as PinterestIcon } from "react-icons/fa"

const supported = {
  facebook: {
    icon: FacebookIcon,
    name: "Facebook",
    shareLink: pageUrl => {
      return `http://www.facebook.com/sharer.php?u=${encodeURIComponent(
        pageUrl
      )}`
    },
  },
  twitter: {
    icon: TwitterIcon,
    name: "Twitter",
    shareLink: pageUrl => {
      return `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        pageUrl
      )}`
    },
  },
  pinterest: {
    icon: PinterestIcon,
    name: "Pinterest",
    shareLink: pageUrl => {
      return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
        pageUrl
      )}`
    },
  },
}

const DrySocialShareButtons = props => {
  const { className, pageUrl, socialNetworks } = props

  const [parsed] = useState(() => {
    return Object.keys(socialNetworks).reduce((prev, curr) => {
      const output = prev
      if (
        Object.keys(supported).includes(curr) &&
        socialNetworks[curr].enable
      ) {
        output[curr] = {
          icon: supported[curr].icon,
          name: supported[curr].name,
          shareLink: supported[curr].shareLink,
          shareText: socialNetworks[curr].shareMessage,
        }
      }
      return output
    }, {})
  })

  return pageUrl && Object.keys(socialNetworks).length ? (
    <div className={className}>
      <ul className="share-icons">
        {Object.keys(parsed).map((social, i) => {
          if (parsed[social].shareLink && parsed[social].icon) {
            const SocialIcon = parsed[social].icon
            return (
              <li className="share-link" key={`share-${social}-${i}`}>
                <a
                  href={parsed[social].shareLink(pageUrl)}
                  rel="nofollow"
                  className={`social-icon icon-${social}`}
                  title={parsed[social].shareText.replace(
                    "%socialnetwork%",
                    parsed[social].name
                  )}
                >
                  <SocialIcon></SocialIcon>
                </a>
              </li>
            )
          }
          return null
        })}
      </ul>
    </div>
  ) : null
}

DrySocialShareButtons.propTypes = {
  className: PropTypes.string,
  pageUrl: PropTypes.string,
  socialNetworks: PropTypes.object,
}

const StyledDrySocialShareButtons = styled(DrySocialShareButtons)`
  margin: 2rem 0;
  .share-icons {
    display: flex;
    justify-content: center;
  }
  .share-link {
    width: 4rem;
    height: 4rem;
    background-color: blue;
    margin: 0 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2rem;
    > a {
      display: flex;
      height: 100%;
      width: 100%;
      justify-content: center;
      align-items: center;
    }
    &:hover {
      background: gray;
    }
    svg {
      width: 2rem;
      height: 2rem;
    }
    path {
      fill: #fff;
    }
  }
`

export default StyledDrySocialShareButtons

export { DrySocialShareButtons }
